module.exports = __webpack_public_path__ + "img/r-k.18a15dc0.png";